import { AxiosRequestConfig } from "axios";
import { Api } from "src/api";
import { httpConfig } from "src/lib/modules/http";

const baseUrl = `${httpConfig.options.baseURL}/media`;

export const restore = (model: string, config?: AxiosRequestConfig): Promise<void> => 
    Api.http.post(`${baseUrl}/${model}/restore`, config);

export const restoreStatus = (model: string, config?: AxiosRequestConfig): Promise<void> => 
  Api.http.get(`${baseUrl}/${model}/restore-status`, config);